// importing the api endpoint ip address
import { API } from "./config";

// backend endpoint for the contact us
export const CONTACT_US = `${API}/contactinquiry/create`;
